var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("Header", { ref: "header" }),
        _c("img", {
          staticClass: "loading",
          attrs: { src: _vm.gameData.topBgImage, alt: "" },
        }),
        _c("div", { staticClass: "item_Options" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("UserInfo", { ref: "userInfo" }),
              _c(
                "div",
                {
                  ref: "iframeContainer",
                  staticClass: "position",
                  staticStyle: {
                    width: "100%",
                    padding: "0",
                    overflow: "hidden",
                    position: "relative",
                  },
                },
                [
                  _vm.isLoading
                    ? _c("div", { staticClass: "loading-progress" }, [
                        _c("div", { staticClass: "progress-bar" }),
                      ])
                    : _vm._e(),
                  _c("iframe", {
                    ref: "activityIframe",
                    staticStyle: { width: "100%", border: "none" },
                    attrs: {
                      src: _vm.getActivityUrl(),
                      scrolling: "no",
                      frameborder: "0",
                    },
                    on: { load: _vm.handleIframeLoad },
                  }),
                ]
              ),
            ],
            1
          ),
        ]),
        _c("Footer"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }